import axios, { type AxiosError, type AxiosResponse } from 'axios';

import { URLS } from '../constants';
import type { UrlsType } from '../types';
import api from './api';
import authApi from './authApi';

// Интерфейс для типичного ответа твоего бэкенда
interface ServerResponse<T> {
  data: T;
  message?: string;
  status?: number;
}

async function request<ResponseType>(
  callback: () => Promise<AxiosResponse<ServerResponse<ResponseType>>>,
): Promise<{ data: ResponseType | null; error: AxiosError | null }> {
  try {
    const response = await callback();
    // ИСПРАВЛЕНО: забираем response.data.data, так как бэкенд оборачивает ответ
    // Добавлена проверка, чтобы не упасть, если бэкенд прислал данные без обертки
    const result = response?.data?.data !== undefined ? response.data.data : (response?.data as any);
    
    return { data: result ?? null, error: null };
  } catch (e) {
    let error: AxiosError | null = null;
    if (axios.isAxiosError(e)) {
      error = e;
      // Логируем ошибку для дебага, чтобы видеть 500-ки в консоли подробнее
      console.error(`[API Error] ${error.config?.url}:`, error.response?.data || error.message);
    } else {
      error = e as AxiosError;
    }
    return { data: null, error };
  }
}

export async function get<ResponseType>(
  key: UrlsType,
  query?: string,
): Promise<{ data: ResponseType | null; error: AxiosError | null }> {
  const url = `${URLS.API_URL}${URLS[key]}${query || ''}`;
  return request(() => api.get<ServerResponse<ResponseType>>(url));
}

export async function post<RequestParams, ResponseType>(
  key: UrlsType,
  params: RequestParams,
  query?: string,
): Promise<{ data: ResponseType | null; error: AxiosError | null }> {
  const url = `${URLS.API_URL}${URLS[key]}${query || ''}`;
  return request(() => api.post<ServerResponse<ResponseType>>(url, params));
}

export async function authPost<RequestParams, ResponseType>(
  key: UrlsType,
  params: RequestParams,
): Promise<{ data: ResponseType | null; error: AxiosError | null }> {
  const url = `${URLS.API_AUTH}${URLS[key]}`;
  return request(() => authApi.post<ServerResponse<ResponseType>>(url, params));
}